<app-filter [countries]="countries" [tags]="tags" (newFilterEvent)="updateFilter($event)"></app-filter>

<app-list [events]="events"></app-list>
